export { ProductOffersModal, ProductOffersBody } from './product-offers-modal'
